<template>
    <div class="col-12 mt-4 mb-4 p-0">
        <b-button v-if="!objectExists" :disabled="disabled" variant="secondary" @click="createAndBack()" class="mr-2 mt-2">Создать и вернуться к списку</b-button>
        <b-button v-if="!objectExists" :disabled="disabled" variant="primary" @click="createAndProceed()" class="mt-2">Создать и открыть карточку</b-button>
        <b-button @click="update" :disabled="disabled" v-if="objectExists && hasChanges" variant="primary" class="mr-2 mt-2">
            <slot name="updateButtonName">
                Сохранить
            </slot>
        </b-button>
        <b-button @click="cancel" v-if="objectExists && hasChanges" variant="secondary" class="mt-2">Отменить изменения</b-button>
    </div>
</template>

<script>
    export default {
        name: "ObjectFormButtons",
        props: {
            objectExists: { type: Boolean, default: false },  // pass object.id here
            hasChanges: { type: Boolean, default: false },  // form is dirty
            disabled: { type: Boolean, default: false }
        },
        methods: {
            cancel() {
                this.$emit('object-cancel-changes');
            },
            update() {
                this.$emit('object-update');
            },
            createAndBack() {
                this.$emit('object-create', {back: true});
            },
            createAndProceed() {
                this.$emit('object-create', {back: false});
            }
        },
    }
</script>

<style scoped lang="scss">
    .updating {

    }
</style>